import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import SaveIcon from '@mui/icons-material/Save';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import EditIcon from '@mui/icons-material/Edit';
import estilos from '../Tabs/TabsInspeccionarComponent.module.css';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import { useContext } from 'react';
import InspectorEnCampoContext from '../../Context/InspectorEnCampoContext';
import { getanexoByIdInforme } from '../../../../redux/DucksUnidadInspeccion/Fi25anexoDuck';
import { insertInstalacionHistorial } from '../../../../redux/DucksUnidadInspeccion/InstalacionesHistorialDuck';
import { getCaratulaByIdInforme } from '../../../../redux/DucksUnidadInspeccion/CaratulaDuck';
import { ReactNotifications } from 'react-notifications-component'
import { Store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'
import { useEffect } from 'react';


function ValidarDomicilioFormComponent(props) {

    const dispatch = useDispatch();
    const { validardomicilioContext, setContextValidarDomicilio } = useContext(InspectorEnCampoContext);

    const [isContext, setIsContext] = React.useState(false);
    const [editarDomicilio, seteditarDomicilio] = React.useState(true);
    const [detalles, setDetalles] = React.useState({
        calle: '',
        numinterior: '',
        numexterior: '',
        cp: '',
        colonia: '',
        municipio: '',
        estado: '',
        pais: '',
        latitud: '',
        longitud: ''

    });

    const idanexo = useSelector(store => store.anexo.anexo);
    const idcaratula = useSelector(store => store.Caratula.caratula);
    const todo = props.detalles;
    const idinforme = props.idinforme;
    const instalacion = props.instalacion - 1;
    const verdaderaInstalacion = props.verdaderaInstalacion;
    const colorAmarillo = 'rgb(249, 231, 159)';
    const colorVerde = 'rgb(208, 236, 231)';


    //const idcaratula = props.idcaratula;

    const handleEditarDomicilio = () => {
        seteditarDomicilio(false);
        let div = document.getElementById('datosDelDomicilio')
        let label = document.getElementById('labelValidarDomicilio')

        div.style.backgroundColor === colorAmarillo ? div.style.backgroundColor = 'white' : div.style.backgroundColor = colorAmarillo
        editarDomicilio === true ? label.style.display = 'inline' : label.style.display = 'none'
    }


    const handleGuardarDomicilio = () => {
        seteditarDomicilio(true);
        let div = document.getElementById('datosDelDomicilio')
        let label = document.getElementById('labelValidarDomicilio')

        div.style.backgroundColor === colorVerde ? div.style.backgroundColor = 'white' : div.style.backgroundColor = colorVerde
        editarDomicilio === false ? label.style.display = 'none' : label.style.display = 'inline'
        editarDomicilio === false ? label.style.html = 'Ahora puede editar:' : label.style.display = 'Cambios guardados'


    }

    React.useEffect(async () => {
        // if (idinforme?.idfi_25_informecumplimientonom) {
        //     dispatch(getanexoByIdInforme(idinforme.idfi_25_informecumplimientonom)) //informe
        //     dispatch(getCaratulaByIdInforme(idinforme.idfi_25_informecumplimientonom))
        // }

        if (validardomicilioContext != null) {
            setIsContext(true)
            setDetalles(
                {
                    calle: validardomicilioContext.data.calle,
                    numinterior: validardomicilioContext.data.numerointerior,
                    numexterior: validardomicilioContext.data.numeroexterior,
                    cp: validardomicilioContext.data.codigopostal,
                    colonia: validardomicilioContext.data.colonia,
                    municipio: validardomicilioContext.data.municipio,
                    estado: validardomicilioContext.data.estado,
                    pais: "Mexico",
                    latitud: validardomicilioContext.data.latitud_domicilio,
                    longitud: validardomicilioContext.data.longitud_domicilio
                }
            )
        } else {
            if (isContext === false) {
                if (todo.idcliente) {
                    if (parseInt(verdaderaInstalacion?.idiformaciongeneralcliente) === parseInt(todo?.anexocliente[instalacion]?.informaciongeneralinstalacioncliente?.idiformaciongeneralcliente)) {
                        setDetalles(
                            {
                                calle: todo.anexocliente[instalacion]?.informaciongeneralinstalacioncliente?.calle,
                                numinterior: todo.anexocliente[instalacion]?.informaciongeneralinstalacioncliente?.numerointerior,
                                numexterior: todo.anexocliente[instalacion]?.informaciongeneralinstalacioncliente?.numeroexterior,
                                cp: todo.anexocliente[instalacion]?.informaciongeneralinstalacioncliente?.codigopostal,
                                colonia: todo.anexocliente[instalacion]?.informaciongeneralinstalacioncliente?.colonia,
                                municipio: todo.anexocliente[instalacion]?.informaciongeneralinstalacioncliente?.municipio,
                                estado: todo.anexocliente[instalacion]?.informaciongeneralinstalacioncliente?.estado,
                                pais: "Mexico",
                                latitud: "",
                                longitud: ""
                            }
                        )
                    }
                }
            }

        }
    }, []);

    useEffect(() => {
        isContext
    }, [isContext])

    return (
        <Fragment>
            <Formik
                initialValues={detalles}
                enableReinitialize={true}
                validate={(valores) => {
                    let errores = {};

                    const data = {
                        data: {
                            //idfi_25caratula: idcaratula?.idfi_25caratula,
                            instalacionnumero: todo.anexocliente[instalacion]?.informaciongeneralinstalacioncliente?.instalacionnumero,
                            alias: todo.anexocliente[instalacion]?.informaciongeneralinstalacioncliente?.alias,
                            calle: valores.calle,
                            numeroexterior: valores.numexterior,
                            numerointerior: valores.numinterior,
                            colonia: valores.colonia,
                            localidad: todo.anexocliente[instalacion]?.informaciongeneralinstalacioncliente?.localidad,
                            municipio: valores.municipio,
                            estado: valores.estado,
                            codigopostal: valores.cp,
                            referenciascercanas: todo.anexocliente[instalacion]?.informaciongeneralinstalacioncliente?.referenciascercanas,
                            domicilio: "",
                            is_domicilio_verificado: true,
                            latitud_domicilio: valores.latitud,
                            longitud_domicilio: valores.longitud,
                            submit: false
                        }
                    }

                    setContextValidarDomicilio(data)

                    if (!valores.calle) {
                        errores.calle = 'Por favor ingresa una calle'
                    }

                    if (!valores.numinterior) {
                        errores.numinterior = 'Por favor ingresa un numero interior'
                    }

                    if (!valores.numexterior) {
                        errores.numexterior = 'Por favor ingresa un numero exterior'
                    }

                    if (!valores.cp) {
                        errores.cp = 'Por favor ingresa un codigo postal'
                    }

                    if (!valores.colonia) {
                        errores.colonia = 'Por favor ingresa una colonia'
                    }

                    if (!valores.municipio) {
                        errores.municipio = 'Por favor ingresa un municipio'
                    }

                    if (!valores.estado) {
                        errores.estado = 'Por favor ingresa un estado'
                    }

                    if (!valores.pais) {
                        errores.pais = 'Por favor ingresa un pais'
                    }

                    if (!valores.latitud) {
                        errores.latitud = 'Por favor ingresa la latitud'
                    }

                    if (!valores.longitud) {
                        errores.longitud = 'Por favor ingresa la longitud'
                    }

                    return errores;
                }}
                onSubmit={(valores) => {
                    //console.log(valores)

                    const data = {
                        data: {
                            //idfi_25caratula: idcaratula.idfi_25caratula,
                            instalacionnumero: todo.anexocliente[instalacion]?.informaciongeneralinstalacioncliente?.instalacionnumero,
                            alias: todo.anexocliente[instalacion]?.informaciongeneralinstalacioncliente?.alias,
                            calle: valores.calle,
                            numeroexterior: valores.numexterior,
                            numerointerior: valores.numinterior,
                            colonia: valores.colonia,
                            localidad: todo.anexocliente[instalacion]?.informaciongeneralinstalacioncliente?.localidad,
                            municipio: valores.municipio,
                            estado: valores.estado,
                            codigopostal: valores.cp,
                            referenciascercanas: todo.anexocliente[instalacion]?.informaciongeneralinstalacioncliente?.referenciascercanas,
                            domicilio: "",
                            is_domicilio_verificado: true,
                            latitud_domicilio: valores.latitud,
                            longitud_domicilio: valores.longitud
                        }
                    }

                    dispatch(insertInstalacionHistorial(data))

                    const dataContext = {
                        data: {
                            //idfi_25caratula: idcaratula?.idfi_25caratula,
                            instalacionnumero: todo.anexocliente[instalacion]?.informaciongeneralinstalacioncliente?.instalacionnumero,
                            alias: todo.anexocliente[instalacion]?.informaciongeneralinstalacioncliente?.alias,
                            calle: valores.calle,
                            numeroexterior: valores.numexterior,
                            numerointerior: valores.numinterior,
                            colonia: valores.colonia,
                            localidad: todo.anexocliente[instalacion]?.informaciongeneralinstalacioncliente?.localidad,
                            municipio: valores.municipio,
                            estado: valores.estado,
                            codigopostal: valores.cp,
                            referenciascercanas: todo.anexocliente[instalacion]?.informaciongeneralinstalacioncliente?.referenciascercanas,
                            domicilio: "",
                            is_domicilio_verificado: true,
                            latitud_domicilio: valores.latitud,
                            longitud_domicilio: valores.longitud,
                            submit: true
                        }
                    }

                    setContextValidarDomicilio(dataContext)

                    Store.addNotification({
                        title: "Domicilio de la Instalación",
                        message: "Verificado exitosamente",
                        type: "success",
                        insert: "center",
                        container: "top-center",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                            duration: 3000,
                            onScreen: true
                        }
                    });
                }}
            >
                {(props) => (
                    <Form><br />
                        <div className={`row ${estilos.tabsSegundoNivel} ${estilos.seccionUI}`}>
                            <div className={`row mb-6 mt-1 mb-3 ${estilos.seccion}`} id='datosDelDomicilio' >
                                <label htmlFor="solicitud" className={`${estilos.labelUI}`}>DATOS DEL DOMICILIO</label>
                                <h6 id="labelValidarDomicilio" style={{ color: 'red', display: 'none' }}>Ahora puede editar:</h6>
                                <div className="col-md-3 mb-3 ">
                                    <label htmlFor="solicitud">Calle</label>
                                    <Field type="text" className="form-control form-control-sm" id="calle" name="calle" placeholder="Calle" disabled={editarDomicilio} required></Field>
                                    <ErrorMessage name='calle' component={() => (
                                        <div className={`${estilos.error}`}>{props.errors.calle}</div>
                                    )} />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label htmlFor="informe">Número Interior</label>
                                    <Field type="text" className="form-control form-control-sm" id="numinterior" name="numinterior" placeholder="Número Interior" disabled={editarDomicilio} required></Field>
                                    <ErrorMessage name='numinterior' component={() => (
                                        <div className={`${estilos.error}`}>{props.errors.numinterior}</div>
                                    )} />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label htmlFor="informe">Número Exterior</label>
                                    <Field type="text" className="form-control form-control-sm" id="numexterior" name="numexterior" placeholder="Número Exterior" disabled={editarDomicilio} required></Field>
                                    <ErrorMessage name='numexterior' component={() => (
                                        <div className={`${estilos.error}`}>{props.errors.numexterior}</div>
                                    )} />
                                </div>

                                <div className="col-md-3 mb-3">
                                    <label htmlFor="escrito">Código Postal</label>
                                    <Field type="text" className="form-control form-control-sm" id="cp" name="cp" placeholder="Codigo Postal" disabled={editarDomicilio} required></Field>
                                    <ErrorMessage name='cp' component={() => (
                                        <div className={`${estilos.error}`}>{props.errors.cp}</div>
                                    )} />
                                </div>
                                <div className="row mb-6">
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="escrito">Colonia o Paraje</label>
                                        <Field type="text" className="form-control form-control-sm" id="colonia" name="colonia" placeholder="Colonia o Paraje" disabled={editarDomicilio} required></Field>
                                        <ErrorMessage name='colonia' component={() => (
                                            <div className={`${estilos.error}`}>{props.errors.colonia}</div>
                                        )} />
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="escrito">Municipio</label>
                                        <Field type="text" className="form-control form-control-sm" id="municipio" name="municipio" placeholder="Municipio" disabled={editarDomicilio} required></Field>
                                        <ErrorMessage name='municipio' component={() => (
                                            <div className={`${estilos.error}`}>{props.errors.municipio}</div>
                                        )} />
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="escrito">Estado</label>
                                        <Field type="text" className="form-control form-control-sm" id="estado" name="estado" placeholder="Estado" disabled={editarDomicilio} required></Field>
                                        <ErrorMessage name='estado' component={() => (
                                            <div className={`${estilos.error}`}>{props.errors.estado}</div>
                                        )} />
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="escrito">País</label>
                                        <Field type="text" className="form-control form-control-sm" id="pais" name="pais" placeholder="Pais" disabled={editarDomicilio} required></Field>
                                        <ErrorMessage name='pais' component={() => (
                                            <div className={`${estilos.error}`}>{props.errors.pais}</div>
                                        )} />
                                    </div>
                                </div>
                                <div className='row mt-3'>
                                    <div className="col-md-4 mb-3">

                                    </div>
                                    {editarDomicilio ?
                                        <div className="col-md-4 mb-3">
                                            <button type="button" className="btn btn-warning" onClick={handleEditarDomicilio}><EditIcon />Modificar Domicilio</button>
                                        </div>
                                        :
                                        <div className="col-md-4 mb-3">
                                            <button type="button" className="btn btn-success" onClick={handleGuardarDomicilio}><SaveIcon />Guardar</button>
                                        </div>
                                    }

                                </div>
                            </div>
                            <div className={`row mb-6 mt-3 mb-3 ${estilos.seccion}`}  >
                                <label htmlFor="solicitud" className={`${estilos.labelUI} mb-2`}>COORDENADAS GEOGRAFICAS</label>

                                <div className='row'>
                                    <div className="col-md-3 mb-3">
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="escrito">Latitud</label>
                                        <Field type="text" className="form-control form-control-sm" id="latitud" name="latitud" placeholder="Latitud" required></Field>
                                        <ErrorMessage name='latitud' component={() => (
                                            <div className={`${estilos.error}`}>{props.errors.latitud}</div>
                                        )} />
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="escrito">Longitud</label>
                                        <Field type="text" className="form-control form-control-sm" id="longitud" name="longitud" placeholder="Longitud" required></Field>
                                        <ErrorMessage name='longitud' component={() => (
                                            <div className={`${estilos.error}`}>{props.errors.longitud}</div>
                                        )} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br></br>
                        {
                            //<div className="row">
                            //
                            //    <div className="col ">
                            //        <button className={`btn ${estilos.botonVerdeCOMERCAM}`} type='submit'>GUARDAR</button>
                            //    </div>
                            //
                            //</div>
                        }
                        <br />
                    </Form>
                )}
            </Formik>
        </Fragment>
    );
};


export default withRouter(ValidarDomicilioFormComponent)
